export default __webpack_public_path__ + "static/media/interior-1.ce7baca9.jpg";